
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { addPaymentMethod, getCustomerPaymentMethods } from '../modules/payment_methods';
import { clearBraintreeFailure } from '../modules/braintree_failure';
import { setupHostedFields, setupPaypal, resetPaypalListener, braintreeObjCreate, braintreeObjDestroy } from '../shared/braintreeClientHelper';
import PayPalButton from './PayPalButton.jsx';
import TermsOfMembership from './CmsTermsOfMembership.jsx';

class CustomBraintreeDropin extends Component {

  constructor(props) {
    super(props);
    this.oSelected = null;
    this.braintreeObj = null;
    this.newPayPalObj = null;
    this.state = {
      viewState : props.paymentMethods && props.paymentMethods.length > 0 ? 'selected' :'none',
      didBrainTreeSubmit: false,
      braintreeErrorObj:  null
    };

    this.viewNone             = this.viewNone.bind(this);
    this.viewSelected         = this.viewSelected.bind(this);
    this.viewSelectedHard     = this.viewSelectedHard.bind(this);
    this.viewAll              = this.viewAll.bind(this);
    this.viewAdd              = this.viewAdd.bind(this);
    this.closePopup           = this.closePopup.bind(this);
    this.braintreeRefresh     = this.braintreeRefresh.bind(this);
    this.submitSelected       = this.submitSelected.bind(this);

    this.braintreeInstantiate = this.braintreeInstantiate.bind(this);
    this.addNewSubmit         = this.addNewSubmit.bind(this);
    this.addNewPaypalSubmit   = this.addNewPaypalSubmit.bind(this);
    this.braintreeFailure     = this.braintreeFailure.bind(this);
  }

  componentWillMount() {
    this.props.dispatch(clearBraintreeFailure());
  }

  braintreeInstantiate(){
    let { uniqueContainer, font_css, customer, tla } = this.props;
    setupHostedFields( uniqueContainer, font_css, uniqueContainer + "-submit", this.addNewSubmit, this.braintreeFailure )
    setupPaypal( uniqueContainer + "-paypal-container", this.addNewPaypalSubmit, this.braintreeFailure)
    braintreeObjCreate(customer.braintree_token, tla);
  }


  componentWillReceiveProps(nextProps){
    if( this.props.paymentMethods !== nextProps.paymentMethods ){
      if( nextProps.paymentMethods && nextProps.paymentMethods[0] ){
        if(this.state.viewState === 'add') braintreeObjDestroy();
        this.viewSelectedHard();
      } else {
        this.viewSelected();
      }
      this.oSelected = null;
      this.newPayPalObj = null;
    }
  }

  componentWillUnmount(){
    this.notMounted = true;
  }

  addNewPaypalSubmit(obj){
    this.newPayPalObj = obj;
    this.viewSelectedHard();
  }

  addNewSubmit(obj){
    let { dispatch, customer, additionalParams, submitFunction } = this.props;
    this.setState({ braintreeErrorObj : {} });
    if( this.state.didBrainTreeSubmit === false ){
      this.newPayPalObj = null;
      this.setState({
        braintreeErrorObj : null,
        didBrainTreeSubmit: true
      });

      this.oSelected = {};
      if (obj.type === "PayPalAccount") this.oSelected.email = obj.details.email;
      else {
        this.oSelected.cardType = obj.details.cardType;
        this.oSelected.maskedNumber = "**" + obj.details.lastTwo;
      }
      this.viewSelectedHard();

      dispatch( addPaymentMethod(obj.nonce, submitFunction, additionalParams, this.braintreeRefresh ) );
    }
  }

  braintreeFailure(err){
    console.log(err);
    this.setState({ braintreeErrorObj : { message : 'Please fill in all the fields.' } });
  }

  braintreeRefresh(){
    let self = this;
    self.viewSelected();
    self.props.dispatch( getCustomerPaymentMethods() );
    setTimeout( function(){
      if(!self.notMounted) self.setState({ didBrainTreeSubmit : false});
    }, 1000);
  }

  viewSelected(){
    if( !this.props.paymentMethods || !this.props.paymentMethods[0]) this.viewNone();
    else this.setState({ viewState: 'selected'});
  }

  viewNone(){ this.setState({ viewState: 'none'}) }
  viewSelectedHard(){ this.setState({ viewState: 'selected'}) }

  viewAll(){
    braintreeObjDestroy();
    this.setState({ viewState: 'listAll'});
  }

  viewAdd(){
    if (this.state.viewState !== 'add'){
      this.setState({ viewState: 'add'});
      let self = this;
      setTimeout( () => self.braintreeInstantiate(), 250);
    }
  }

  closePopup(){
    if(this.state.viewState === 'add') braintreeObjDestroy();
    if(this.oSelected) this.viewSelectedHard();
    else this.viewNone();
  }

  selectPaymentMethod(paymentMethodObj){
    this.setState({ viewState: 'selected'});
    this.newPayPalObj = null;
    this.oSelected = paymentMethodObj;
  }

  submitSelected(){
    let { customer, additionalParams, submitFunction, dispatch } = this.props;
    if ( this.state.didBrainTreeSubmit === false  ){
      this.setState({ didBrainTreeSubmit: true });


      dispatch( submitFunction(null, this.oSelected.token, this.braintreeRefresh, additionalParams) );
    }
  }

  render() {
    let oPaymentMethodList           = '',
      elem                           = '',
      oSelectedObj                   = '',
      oPaypalObj                     = '',
      oShowChangePaymentMethodButton = '',
      paymentError                   = '',
      popupBackDrop                  = null,
      popupContents                  = '',
      braintreeEmbedElem             = '',
      braintreePopupElem             = '',
      paymentMethods                 = this.props.paymentMethods,
      braintreeErrors                = this.state.braintreeErrorObj,
      currentView                    = this.state.viewState;

    if( currentView === 'add' || currentView === 'listAll' )
      popupBackDrop = (<div className="modal-wrapper showing" onClick={this.closePopup}></div>);

    if( paymentMethods && currentView !== 'none' ){
      oPaymentMethodList = paymentMethods.map((method, i) => {
        if (method && typeof method === 'object') {
          let oSetDefault = method.default === false ? '': (<span className="text-small">Default</span>);
          let sCardType = method.cardType;
          if (method.cardType === 'American Express' ) sCardType = 'AmEx';
          if( this.oSelected === null && method.default === true ) this.oSelected = method;

          return (
            <li className={ method.default === true ? "default" : ""} onClick={this.selectPaymentMethod.bind(this, method)}  key={'PaymentMethod' + i}>
              <span className="radio-icon"></span>
              { method.cardType ? sCardType + " ending in " + method.maskedNumber.substr(-4,4) : "PayPal " + method.email }
               {oSetDefault}
            </li>
          );
        } else {
          return '';
        }
      });
    }

    if(this.oSelected ){
      oSelectedObj = (
        <li className={ this.oSelected.default === true ? "default" : ""}>
          <div className="payment-info"> { this.oSelected.cardType ? this.oSelected.cardType + " ending in " + this.oSelected.maskedNumber.substr(-4,4) : "PayPal " + this.oSelected.email } </div>
        </li>
      );
    }
    if(this.newPayPalObj ){
      oPaypalObj = (
        <li>
          <div className="payment-info"> { "PayPal " + this.newPayPalObj.details.email } </div>
        </li>
      );
    }

    oShowChangePaymentMethodButton = this.state.didBrainTreeSubmit === true ? '' :
      ( <div className="edit-link" onClick={this.viewAll}>{ this.props.uniqueContainer && this.props.uniqueContainer.includes("preorder") ? "Edit" : "Change Payment Method" }</div>);
    if(this.props.braintreeFailure && !this.state.didBrainTreeSubmit ) paymentError = (<div className="errorMessage">{this.props.braintreeFailure}</div>);

    if( currentView !== 'none' && this.oSelected ){
      braintreeEmbedElem = (
       <div className="selectedPayment showing">
        { this.newPayPalObj ? oPaypalObj : oSelectedObj }
        {oShowChangePaymentMethodButton}
        <button
          className="btn-primary fat full-width"
          id={ currentView !== 'add' ? this.props.uniqueContainer + "-submit": ""}
          onClick={ this.newPayPalObj ? this.addNewSubmit.bind(this, this.newPayPalObj) : this.submitSelected} >
            { this.state.didBrainTreeSubmit === false ? (this.props.uniqueContainer && this.props.uniqueContainer.includes("one-time") ? "Checkout" : "Place Order" ) : "Pending..." }
        </button>
      </div>
      );
    } else if(currentView !== 'selected' && !this.oSelected ){
      braintreeEmbedElem = (
        <div className="noPaymentMethod showing">
          <p>You do not have a payment method on file. Please add a payment method to make a purchase.</p>
          <button className="btn-primary fat full-width" onClick={this.viewAdd}>Add Payment Method</button>
        </div>
      );
    }

    switch( currentView ) {
      case 'listAll':
        popupContents = (
          <ul className="paymentMethodList showing">
            <h2 >Select a Payment Method</h2>
            {oPaymentMethodList}
            <li onClick={this.viewAdd} className="button"><div className="btn-icon">+</div>Add Another Payment Method</li>
            <div className="help-link center" onClick={this.closePopup}> cancel </div>
          </ul>
        );
        break;
      case 'add':
        popupContents = (
          <div className="hostedFieldForm showing" id={this.props.uniqueContainer}>
            {(<h2>Please enter your payment method</h2>)}
            {(braintreeErrors && braintreeErrors.message) || (this.props.braintreeFailure && !this.state.didBrainTreeSubmit) ?
              (<p className="errorMessage">{ braintreeErrors && braintreeErrors.message ? braintreeErrors.message : this.props.braintreeFailure }</p>) : ''}

            <label>Credit Card Number</label>
            <div id="card-number" className="hostedFieldInput"></div>

            <label>CVV</label>
            <div id="cvv" className="hostedFieldInput"></div>

            <label>Expiration Date (MM/YYYY)</label>
            <div id="expiration-date" className="hostedFieldInput"></div>

            <label>Zipcode</label>
            <div id="postalCode" className="hostedFieldInput"></div>

            <button className="btn-primary fat full-width showing" id={this.props.uniqueContainer + "-submit"} disabled={true} type="submit">{ this.state.didBrainTreeSubmit === false ? "Checkout" : "Pending..." }</button>
            { this.props.tla === "DVD" ? (<div />) : (
              <div id={this.props.uniqueContainer + "-paypal-container"} className="bt-paypal-button">
                <PayPalButton />
              </div>
            )}

            <div className="help-link center" onClick={ !paymentMethods || !paymentMethods[0] ? this.viewNone : this.viewAll}> cancel </div>
          </div>
        );
        break;
    }

    if( popupContents ){
      braintreePopupElem = (
        <div className="modal-window showing">
          <div className="modal-close" onClick={this.closePopup}>&times;</div>
          {popupContents}
        </div>
      );
    }

    return (
      <div className="braintreeObj">
          {paymentError}
          {popupBackDrop}
          {braintreeEmbedElem}
          {braintreePopupElem}
      </div>
    );
  }
};

function mapStateToProps(state){
    return {
      'customer': state.customer,
      'paymentMethods': state.paymentMethods,
      'tla': state.store.tla,
      'braintreeFailure': state.braintreeFailure,
      'font_css': state.store.font_css
    };
}

export default connect(mapStateToProps, null, null, {withRef: true})(CustomBraintreeDropin);


// WEBPACK FOOTER //
// ./src/components/CustomBraintreeDropin.jsx